import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=1db0a176&"
import script from "./SummaryTable.vue?vue&type=script&lang=js&"
export * from "./SummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports